import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

export interface DateConfirmationData {
  textKey?: string | LocLabel;
  acceptKey: string;
  cancelKey?: string;
  minDate: Date;
  maxDate: Date;
}

@Component({
  selector: 'app-date-confirmation-dialog',
  templateUrl: './date-confirmation-dialog.component.html',
  styleUrls: ['./date-confirmation-dialog.component.scss']
})
export class DateConfirmationDialogComponent implements OnInit {
  public date: FormControl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DateConfirmationData) {
    this.date = new FormControl(null);
  }

  ngOnInit(): void {}
}
